import { Module } from 'vuex';
import {RootState} from "@/store/types";
import {UserState} from "./types";
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: UserState = {
  allowedPages: []
}

export const userModule: Module<UserState, RootState> = {
  state,
  getters,
  actions,
  mutations
}